'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.checkRoles = exports.checkRole = exports.checkAuthenticated = void 0;
const thunks_1 = require('./thunks');
// export const checkAuthenticated = async (suppressError:boolean = false, redirectOnError:boolean|string = true) => {
exports.checkAuthenticated = async (options = { suppressError: true }) => {
  var _a, _b, _c;
  if (!thunks_1.getStore()) {
    throw new Error(
      'Store not found. Please call setStore() before using auth guards.',
    );
  }
  if (
    !(
      (_a = thunks_1.getStore()) === null || _a === void 0
        ? void 0
        : _a.getState().auth
    ).initialized
  ) {
    let unsubscribe;
    await new Promise((resolve) => {
      var _a;
      unsubscribe =
        (_a = thunks_1.getStore()) === null || _a === void 0
          ? void 0
          : _a.subscribe(() => {
              var _a;
              if (
                ((_a = thunks_1.getStore()) === null || _a === void 0
                  ? void 0
                  : _a.getState().auth
                ).initialized
              ) {
                resolve();
              }
            });
    });
    if (unsubscribe) {
      unsubscribe();
    }
  }
  if (
    !(
      (_b = thunks_1.getStore()) === null || _b === void 0
        ? void 0
        : _b.getState().auth
    ).decodedAccessToken
  ) {
    if (options.errorMessage) {
      thunks_1
        .getStore()
        .dispatch(
          thunks_1.accessDeniedMessage(
            typeof options.errorMessage === 'string'
              ? options.errorMessage
              : thunks_1.getStore().getState().auth.defaultAccessDeniedMessage,
          ),
        );
    }
    if (options.suppressError) {
      return false;
    }
    if (options.redirectOnError) {
      thunks_1
        .routerAdapter()
        .go(
          options.redirectOnErrorRoute ||
            ((_c = thunks_1.getStore()) === null || _c === void 0
              ? void 0
              : _c.getState().auth
            ).signOutRoute,
        );
    }
    throw new Error('Access denied: user not authenticated');
  }
  // verify token validity?
  return true;
};
exports.checkRole = async (roles, options = { suppressError: true }) => {
  var _a, _b, _c;
  try {
    await exports.checkAuthenticated({
      suppressError: false,
      redirectOnError: false,
    });
    const userRoles =
      ((_b = (
        (_a = thunks_1.getStore()) === null || _a === void 0
          ? void 0
          : _a.getState().auth
      ).decodedAccessToken.roles) === null || _b === void 0
        ? void 0
        : _b.split(',')) || [];
    const hasSomeRoles = roles.some((el) => userRoles.includes(el));
    if (!hasSomeRoles) {
      throw new Error(
        `Access denied: user does not have one of the required roles: ${roles === null || roles === void 0 ? void 0 : roles.join(',')}`,
      );
    }
    return true;
  } catch (e) {
    if (options.errorMessage) {
      thunks_1
        .getStore()
        .dispatch(
          thunks_1.accessDeniedMessage(
            typeof options.errorMessage === 'string'
              ? options.errorMessage
              : thunks_1.getStore().getState().auth.defaultAccessDeniedMessage,
          ),
        );
    }
    if (options.suppressError) {
      return false;
    }
    if (options.redirectOnError) {
      thunks_1
        .routerAdapter()
        .go(
          options.redirectOnErrorRoute ||
            ((_c = thunks_1.getStore()) === null || _c === void 0
              ? void 0
              : _c.getState().auth
            ).signInRoute,
        );
    }
    throw e;
  }
};
exports.checkRoles = async (roles, options = { redirectOnError: true }) => {
  var _a, _b, _c;
  try {
    await exports.checkAuthenticated({
      suppressError: false,
      redirectOnError: false,
    });
    const userRoles =
      ((_b = (
        (_a = thunks_1.getStore()) === null || _a === void 0
          ? void 0
          : _a.getState().auth
      ).decodedAccessToken.roles) === null || _b === void 0
        ? void 0
        : _b.split(',')) || [];
    const hasEveryRoles = roles.every((el) => userRoles.includes(el));
    if (!hasEveryRoles) {
      throw new Error(
        `Access denied: user does not have all of the required roles: ${roles === null || roles === void 0 ? void 0 : roles.join(',')}`,
      );
    }
    return true;
  } catch (e) {
    if (options.errorMessage) {
      thunks_1
        .getStore()
        .dispatch(
          thunks_1.accessDeniedMessage(
            typeof options.errorMessage === 'string'
              ? options.errorMessage
              : thunks_1.getStore().getState().auth.defaultAccessDeniedMessage,
          ),
        );
    }
    if (options.suppressError) {
      return false;
    }
    if (options.redirectOnError) {
      thunks_1
        .routerAdapter()
        .go(
          options.redirectOnErrorRoute ||
            ((_c = thunks_1.getStore()) === null || _c === void 0
              ? void 0
              : _c.getState().auth
            ).signInRoute,
        );
    }
    throw e;
  }
};
